import {
  CapacitorUpdater,
  type DownloadCompleteEvent,
} from '@capgo/capacitor-updater';
import { toast } from 'sonner';

import { useOnOtaUpdateDownloaded } from './useOnOtaUpdateDownloaded';

/**
 * Handles Capgo OTA bundle updates by listening for downloaded bundles
 * and prompting user to apply them.
 *
 * NOTE: notifyAppReady() is called in src/integrations/capacitor/appReady.ts
 * BEFORE React initialization to prevent rollback if React crashes.
 */
export function useOtaUpdates() {
  useOnOtaUpdateDownloaded((event: DownloadCompleteEvent) => {
    toast('Update ready', {
      description: `Version ${event.bundle.version} downloaded`,
      action: {
        label: 'Apply now',
        onClick: () => CapacitorUpdater.reload(),
      },
      duration: Infinity,
    });
  });
}
